import { useDispatch } from 'react-redux'
import MediaQuery from 'react-responsive'
import classnames from 'classnames'
import { withTranslate } from 'i18n/utils'

import DownloadApp from 'shared/components/DownloadApp'
import SpecialOffers from 'shared/components/SpecialOffers'
import { GRID_BREAKPOINT_SM, GRID_BREAKPOINT_MD } from 'shared/breakpoints'
import Button from 'shared/components/Button'
import { openCookiesModal } from 'cookies/actions'
import featureToggles from 'shared/featureToggles'

import FindAndBook from './FindAndBook'
import WhyChoose from './WhyChoose'
import Offers from './Offers'
import Services from './Services/Services'
import Career from './Career'
import Corporate from './Corporate'
import Partners from './Partners'
import NpsModalView from './NpsModalView'

const HomeView = () => (
    <div className="home-container">
        <FindAndBook />
        <SpecialOffers />
        <WhyChoose />
        <Offers />
        <NpsModalView />
        <MediaQuery maxWidth={GRID_BREAKPOINT_SM - 1}>
            <Services itemsPerSlide={2} />
        </MediaQuery>
        <MediaQuery minWidth={GRID_BREAKPOINT_SM} maxWidth={GRID_BREAKPOINT_MD - 1}>
            <Services itemsPerSlide={3} />
        </MediaQuery>
        <MediaQuery minWidth={GRID_BREAKPOINT_MD}>
            <Services itemsPerSlide={5} />
        </MediaQuery>
        <Partners />
        <Corporate />
        <DownloadApp />
        <Career />
    </div>
)
export default withTranslate(HomeView)
